<template>
  <div class="product-details">
    <!-- 头部导航 -->
    <div class="header">
      <div class="image-carousel">
        <van-swipe class="swipe-container" :autoplay="3000" indicator-color="#fff">
          <van-swipe-item v-for="(image, index) in productImages" :key="index">
            <div class="swipe-image">
              <img :src="image.url" alt="产品图片">
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- 产品标题和价格 -->
      <div class="product-info">
        <h1 class="product-title">{{ productInfo.name }}</h1>
        <div class="product-price">
          <span class="price">¥ ****.**</span>
          <span class="price-info">价格咨询请联系销售</span>
        </div>
      </div>
    </div>

    <!-- 选项卡导航 -->
    <van-tabs v-model="activeTab" sticky animated swipeable>
      <van-tab title="图文介绍">
        <div class="tab-content">
          <h2 class="tab-title">图文介绍</h2>
          <div class="image-content" v-if="productInfo.imageText">
            <img v-for="(item, index) in JSON.parse(productInfo.imageText)" :src="item.url" alt="图文介绍" :key="index">
          </div>
        </div>
      </van-tab>

      <van-tab title="视频介绍">
        <div class="tab-content">
          <h2 class="tab-title">视频介绍</h2>
          <div class="video-container" v-if="productInfo.videos">
            <div v-for="(item, index) in JSON.parse(productInfo.videos)" :key="index" class="video-item">
              <video :src="item.url" controls preload="metadata" class="video-player"
                style="width: 100%; height: auto; max-height: 300px; margin-bottom: 16px;"></video>
              <div class="video-title" v-if="item.title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="相关案例">
        <div class="tab-content">
          <h2 class="tab-title">相关案例</h2>
          <div class="case-list" v-if="productInfo.xgal">
            <div v-for="(item, index) in JSON.parse(productInfo.xgal)" :key="index" class="case-item"
              @click="goToCase(item)">
              <div class="case-content">
                <span class="case-title">{{ item.fileName }}</span>
                <van-icon name="arrow" />
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="apply-button-container">
      <van-button type="default" block @click="handleApply">申请使用</van-button>
    </div>
    <AppTabbar></AppTabbar>
  </div>
</template>

<script>

import { getProductDetail, applyTrial } from '@/api/index'
import AppTabbar from '@/components/AppTabbar'
import { Toast } from 'vant';

export default {
  name: 'ProductDetails',
  components: {
    AppTabbar
  },

  data() {
    return {
      activeTab: 0,
      productInfo: {
        id: 1,
        title: '猎寻网络舆情监测系统服务-T版(网络舆情监测/网络信息监测)一年服务费',
        price: '****.**',
        descriptionImage: require('@/assets/product/LxwlzjscL.png')
      },
      productImages: [
      ],
      videoOptions: {
        sources: [{
          type: 'video/mp4',
          src: 'https://example.com/video.mp4'
        }],
        poster: require('@/assets/product/LxwlzjscL.png')
      },
    }
  },
  mounted() {
    // this.$refs.videoPlayer.player.play()
    console.log('123');
    this.getProductDetail()
  },
  methods: {
    //获取产品详情
    getProductDetail() {
      //获取路由参数id
      const id = this.$route.query.id
      getProductDetail(id).then(res => {
        console.log(res);
        this.productImages = res.image ? JSON.parse(res.image) : []
        this.productInfo = res
      })
    },
    handleApply() {
      let data = {
        systemName: this.productInfo.name,
        systemId: this.productInfo.id,
      }
      applyTrial(data).then(res => {
        console.log(res);
        Toast('提交成功！');
        this.form = {};
        this.loading = false;
      })
    },
    goToCase(item) {
      this.$router.push({
        path: '/productCase',
        query: {
          url: item.fileUrl,
          id: this.$route.query.id
        }
      })

    }
  }
}
</script>

<style scoped>
.product-details {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.header {
  background-color: #fff;
  padding: 20px;
}

.status-bar {
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  text-align: center;
  font-size: 14px;
  color: #000;
  font-weight: bold;
}

.image-carousel {
  position: relative;
  height: 280px;
  /* background-color: #eee; */
}

.back-button {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 36px;
  height: 36px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  color: #fff;
}

.swipe-container {
  height: 100%;
}

.swipe-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swipe-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.custom-indicator {
  position: absolute;
  right: 16px;
  bottom: 16px;
  padding: 5px 10px;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
}

.product-info {
  padding: 16px;
}

.product-title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 12px;
  line-height: 1.4;
  color: #333;
}

.product-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price {
  font-size: 18px;
  color: #f00;
  font-weight: bold;
}

.price-info {
  font-size: 12px;
  color: #999;
}

.tab-content {
  padding: 16px;
  background-color: #fff;
}

.tab-title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 16px;
  color: #333;
}

.image-content,
.video-container {
  width: 100%;
  min-height: 200px;
  background-color: #eee;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.image-content img {
  width: 100%;
}

.case-list {
  margin-bottom: 16px;
}

.case-item {
  padding: 16px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.case-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.case-title {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.bottom-actions {
  margin-top: auto;
}

.apply-button-container {
  padding: 10px 16px;
  background-color: #fff;
  margin-bottom: 60px;
}

.bottom-tabs {
  display: flex;
  height: 50px;
  background-color: #fff;
  border-top: 1px solid #eee;
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
}

.tab-item i {
  font-size: 20px;
  margin-bottom: 4px;
}

/* Vant组件自定义样式 */
:deep(.van-tabs__line) {
  background-color: #000;
}

:deep(.van-button--default) {
  background-color: #999;
  border: none;
  color: #fff;
  border-radius: 4px;
  height: 44px;
  font-size: 16px;
}
</style>
